import React, { useState, useEffect } from 'react';
import API from '../utils/gasClient';
import { Loading } from '../components/Loading';
import { TicketSelectionPage } from './TicketSelectionPage';

export const TicketSelectionPageContainer = ({ 
  event,
  pedido,
  setPedido,
  onNavigate,
  onVoltar
}) => {
  const [lotes, setLotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLotes = async () => {
      try {
        setLoading(true);
        
        const lotesData = await API.getSpreadsheetData('lotes', event?.eventId);
        
        // Ordena os lotes por data de fim
        const lotesOrdenados = lotesData.sort((a, b) => {
          return new Date(a.dataFim) - new Date(b.dataFim);
        });

        setLotes(lotesOrdenados);
        setLoading(false);
      } catch (err) {
        console.error('❌ Erro ao buscar lotes:', err);
        setError('Não foi possível carregar os lotes disponíveis.');
        setLoading(false);
      }
    };

    if (event?.eventId) {
      fetchLotes();
    }
  }, [event]);

  const handleQuantityUpdate = (loteName, newQuantity) => {
    const lote = lotes.find(l => l.nome_lote === loteName);
    if (!lote) return;

    const novosPedidos = { ...pedido.ingressos };
    
    if (newQuantity === 0) {
      delete novosPedidos[loteName];
    } else {
      novosPedidos[loteName] = newQuantity;
    }

    // Calcula novo total
    const novoTotal = Object.entries(novosPedidos).reduce((acc, [nome, qtd]) => {
      const loteItem = lotes.find(l => l.nome_lote === nome);
      return acc + (loteItem?.valor || 0) * qtd;
    }, 0);

    setPedido({
      ...pedido,
      ingressos: novosPedidos,
      total: novoTotal
    });
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="text-center">
          <p className="text-red-600 mb-4">{error}</p>
          <button
            onClick={onVoltar}
            className="px-6 py-2 bg-primary text-white rounded-full hover:bg-primary-hover transition-colors duration-300"
          >
            Voltar
          </button>
        </div>
      </div>
    );
  }

  return (
    <TicketSelectionPage
      pedido={pedido}
      onQuantityUpdate={handleQuantityUpdate}
      onNavigate={(page) => {
        // Garante navegação absoluta removendo paths anteriores
        const cleanPage = page.split('/').pop();
        onNavigate(cleanPage);
      }}
      lotes={lotes}
    />
  );
};
